<template>
  <zen-one 
  :showuserinfo="false" 
  title=""
  :crumbs="crumbs"
  >
  <z-page
  title="Daerah"
  >

  <w-dialog
  ref="draggableDialog"
  v-model="dialog.show"
  :fullscreen="dialog.fullscreen"
  :width="dialog.width"
  :persistent="dialog.persistent"
  :persistent-no-animation="dialog.persistentNoAnimation"
  title-class="primary-dark1--bg white"
>


    <template #title>
  <div
    class="dialog-title-dragger"
    @mousedown="initDrag"
    style="cursor: move; display: flex; align-items: center;"
  >
    <w-icon class="mr2">fal fa-cog</w-icon>
    {{ dialog.title }}
  </div>
</template>


    <w-form 
      ref="form" 
      v-model="dialog.valid"
    >
    <z-select :items="negara" class="mt4" label="Negara"  v-model="form.lkp_negara_id"  @input="getNegeri()" :validators="[validators.required]" readonly></z-select>
    <z-select :items="negeri" class="mt4" label="Negeri"  v-model="form.lkp_negeri_id" :validators="[validators.required]"></z-select>
    <!-- <z-input label="Kod" v-model="form.kode" name="Kode" :validators="[validators.required]" /> -->
    <z-input label="Nama" v-model="form.nama" name="Nama" :validators="[validators.required]" />
    </w-form>
        

    
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">TUTUP</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      @click="validateAndSubmit"
      >
        SIMPAN
      </w-button>
    </template>

    
  </w-dialog>
  

  <z-table
    ref="tbluser"
    title="Daerah"
    :headers="table.headers"  
    :items="table.items"
    :meta="table.meta"
    class=""
  >


 
  <template #button>
        <w-button dark class="green--bg ml1" @click="add()">
            <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
        </w-button>
    </template>
   
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>
    
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="fs-2 pr3 bs" bg-color="orange-light3" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI

        </w-button>
        &nbsp;  
        <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2"> fal fa-trash</w-icon>PADAM
        </w-button>
       &nbsp;
       
        
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'penyelenggaraan.daerah',
      crumbs: [
        { label: this.$page.props.app_name, route: '/' },
        { label: 'Penyelenggaraan', route: '/penyelenggaraan' },
        { label: 'Daerah', route: '/penyelenggaraan/daerah' }
      ],
      
      form: {
        id: 0,
        nama: '',
        kode: '',
        lkp_negeri_id:1,
      },
      negeri:[],
      negara:[],
    }
  },
   methods: {
      add(){
           this.form = {
              id : null,
              nama : null,
              kode : null,
              lkp_negeri_id : '',
              lkp_negara_id : 1,

          }
          this.getNegeri()
          this.dialog.show = true
          this.dialog.title = 'TAMBAH'
          this.form.saveButton = "Save"
      },
      edit(form){
          this.form = form
          this.getNegeri()
          this.dialog.show = true
          this.dialog.title = 'KEMASKINI'
          this.form.saveButton = "Save"
      },

      getNegeri(){
        this.$zcomm.get(this.api_service + 'lookup/negeri/'+this.form.lkp_negara_id, {}).then(res => {
          this.negeri = res
        
        })
      },

      async validateAndSubmit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        return
      }
      this.submit()
    },

      initDrag(e) {
        const dialog = this.$refs.draggableDialog?.$el;
        const content = dialog?.querySelector('.w-dialog__content');
        if (!content) return;

        content.style.position = 'fixed';
         content.style.margin = 0;
         content.style.width = dialog.style.width || '500px'; // atur lebar agar tidak mengecil
         content.style.zIndex = 1050; // pastikan di atas


        const startX = e.clientX;
        const startY = e.clientY;
        const rect = content.getBoundingClientRect();
        const origLeft = rect.left;
        const origTop = rect.top;

        const onMouseMove = (event) => {
          const dx = event.clientX - startX;
          const dy = event.clientY - startY;
          content.style.left = `${origLeft + dx}px`;
          content.style.top = `${origTop + dy}px`;
        };

        const onMouseUp = () => {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      },

      getNegara(){
        this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
          this.negara = res

        })
      },
  },

  watch: {

  },
  mounted() {
    this.getNegara()
    // override default setting
    this.dialog.width = 500
  
      
  },
}
</script>
<style scoped>
.w-dialog {
  position: fixed !important;
}
.draggable-dialog {
  position: fixed !important;
  margin: 0 !important;
  width: 500px !important;
  z-index: 1050;
}

</style>


